module.exports = __webpack_public_path__ + "static/media/logo.min.0dce119a.svg";